
import React from 'react'
import { Tabs, Button, Pagination, message, notification } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import NoData from '../com/NoData';
import { tagRedirect } from '../com/utils';
import Table from './com/table';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class favorite extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      total: 0,
      pageSize: 10,

      tabValue: "1",
      data: [],
    }
  }
  async componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {

  }

  onTabChange = async (value) => {
    await this.setState({ tabValue: value, page: 1, pageSize: 10, data: [] });
    this.loadData();
  }

  cancelFavorite = (data) => {
    this.modalRef.open();
    this.setState({ checkData: data });
  }

  loadData = () => {
    const { page, pageSize, tabValue } = this.state;
    let params = {
      page, records: pageSize
    }
    if (tabValue === '2') params['favor'] = true
    const onLoadData = (res) => {
      if (res.status == 0) {
        this.setState({ data: res.results, total: res.results.length });
      } else {
        this.setState({ data: [] });
      }
    }
    let url = tabValue === '1' ? '/applicant/favor_list' : '/enterprise/search'
    WidgetAjax.ajax({ url: path + url, params, callback: onLoadData });
  }

  favor = () => {
    const { checkData, tabValue } = this.state;
    if (!checkData) return
    let params = {}
    if (tabValue === '1') {
      params['job_id'] = checkData?.job_id;
    } else {
      params['id'] = checkData?.id;
    }
    const onFavor = (res) => {
      if (res.status == 0) {
        message.success("成功!");
        this.loadData();
        this.setState({ checkData: undefined });
        if (this.props && this.props.onChange) this.props.onChange();
      } else {
        message.error("失败");
      }
    }
    let url = tabValue === '1' ? '/job/unfavor' : '/enterprise/unfavor';
    WidgetAjax.ajax({ url: path + url, params, callback: onFavor });

  }

  application_add = (id) => {
    WidgetAjax.ajax({
      url: path + "/job/application_add",
      params: { job_id: id },
      callback: (res) => {
        if (res.status == 0) {
          this.loadData();
          if (this.props && this.props.onChange) this.props.onChange();
          notification.open({
            message: '报名成功',
            description: '报名成功',
            placement: 'top',
            duration: 2
          });
        }
      },
    });
  }




  operate = (data) => {
    return <>
      <Button className='op-btn-likes' style={{ marginRight: "16px" }} onClick={() => { this.cancelFavorite(data) }}>取消收藏</Button>

      {
        data && data?.application ?
          <Button disabled >已申请</Button>
          :
          <Button onClick={() => { this.application_add(data?.job_id) }} type="primary">职位申请</Button>
      }
    </>
  }

  onPageChange = async (page, pageSize) => {
    await this.setState({ page, pageSize });
    this.loadData();
  }



  render() {
    const {tabValue, data, page, total, pageSize } = this.state;
    let tabsData = [
      { key: '1', label: `职位收藏(${this.props.data?.favor_jobs || 0})` },
      { key: '2', label: `企业收藏(${this.props.data?.favor_enterprises || 0})` }
    ]
    return <div className='feedback'>
      <div className='feedback_box'>
        <Tabs items={tabsData} onChange={this.onTabChange} />
      </div>
      <div className='table'>
        {
          tabValue === '1' ?
            <Table data={data} options={{ operate: true }} operate={this.operate} />
            :

            <div className='ent_table_box'>

              {
                data && data.length ?
                data && data.map((item) => {
                  return <div className='ent_item sf-page-tool-between'>
                    <div>
                      <div className='ent_info'>
                        <img src={require("../../img/pinzhunzhun/enterprise/ent-logo.png")} />
                        <div>
                          <div className='ent_name' onClick={() => tagRedirect({ enterprise_key: item?.id }, 'enterprise/detail')}>{item?.ENTNAME}</div>
                          <div className='ent_detail'>
                            <div className='ellipsis-text' title={item?.INDTYPE_CN}>{item.INDTYPE_CN ? item.INDTYPE_CN : null}</div>
                            {item.SCALE_CN ? <div> | </div> : null}
                            {item.SCALE_CN ? item.SCALE_CN : null}
                            {item.ENTTYPE_CN ? <div > | </div> : null}
                            {item.ENTTYPE_CN ? item.ENTTYPE_CN : null}
                          </div>
                        </div>
                      </div>
                      <div className='job_tag_box'>
                        {
                          item.TAG && (item.TAG.map((item) => {
                            return <div className='job_tag'>{item}</div>
                          }))
                        }
                      </div>
                    </div>
                    <div className='job-detail-op'>
                      <Button className='op-btn-likes' onClick={() => this.cancelFavorite(item)} >取消收藏</Button>
                    </div>
                  </div>
                })
                :<NoData width={'400px'} height={'400px'} />
              }
            </div>
        }
        <div className="cardtable-pagination">
          <Pagination
            showQuickJumper
            hideOnSinglePage={true}
            defaultCurrent={page}
            total={total}
            pageSize={pageSize}
            pageSizeOptions={[10, 20, 50, 100]}
            onChange={this.onPageChange}
          />
        </div>
      </div>

      <WidgetModal onRef={ref => this.modalRef = ref} options={{ title: "取消收藏", width: 500 }} onOk={() => this.favor()}>
        您确认要取消吗?
      </WidgetModal>


    </div>
  }
}

export default favorite;